"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8883],{

/***/ 38883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pop_up; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/isomorphic-cookie/dist/index.js
var dist = __webpack_require__(38139);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/toggled/dist/toggled.esm.js
var toggled_esm = __webpack_require__(67866);
// EXTERNAL MODULE: ./src/gql/queries/index.ts + 45 modules
var queries = __webpack_require__(98);
// EXTERNAL MODULE: ./src/hooks/use-isomorphic-layout-effect.ts
var use_isomorphic_layout_effect = __webpack_require__(85813);
// EXTERNAL MODULE: ./src/hooks/use-modal-manager.ts
var use_modal_manager = __webpack_require__(63637);
// EXTERNAL MODULE: ./src/hooks/use-vendor.ts
var use_vendor = __webpack_require__(1360);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./src/components/buying-in-store-selector/index.tsx + 1 modules
var buying_in_store_selector = __webpack_require__(15044);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/index.ts + 30 modules
var hooks = __webpack_require__(91497);
// EXTERNAL MODULE: ./src/truck/new-button/NewButton.tsx + 4 modules
var NewButton = __webpack_require__(8262);
;// CONCATENATED MODULE: ./src/components/cookies-alert/index.tsx






function CookiesAlert(param) {
    var modalId = param.modalId;
    var onClick = function onClick() {
        dist_default().save(constants/* cookieNames.ACCEPTED_COOKIES */.Qo.ACCEPTED_COOKIES, 1, {
            secure: false
        });
        closeModal(modalId);
    };
    var vendor = (0,hooks/* useVendor */.at)();
    var closeModal = (0,hooks/* useModalManager */.$C)().closeModal;
    // FIXME: replace color (charade) and z-index (cookiesBanner)
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fixed inset-x-0 bottom-0 z-[25] flex flex-col items-center gap-6 bg-[#2d333c] p-6 lg:flex-row lg:justify-between lg:gap-12 lg:p-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm font-semibold text-white lg:text-xs",
                        children: "Esta p\xe1gina web usa cookies"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-sm text-white lg:text-xs",
                        children: [
                            "Las cookies de este sitio web se usan para personalizar el contenido y analizar el tr\xe1fico. Al continuar usando este sitio web aceptas el uso de las cookies de acuerdo a nuestra",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "underline",
                                href: vendor.cookiesPolicyUrl,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "pol\xedtica de cookies"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full shrink-0 lg:w-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewButton/* default */.Z, {
                    variant: "secondary",
                    onClick: onClick,
                    className: "min-w-32",
                    children: "Aceptar"
                })
            })
        ]
    });
}
/* harmony default export */ var cookies_alert = (CookiesAlert);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.es.js
var polished_es = __webpack_require__(74808);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/truck/button/index.tsx + 2 modules
var truck_button = __webpack_require__(48721);
// EXTERNAL MODULE: ./src/truck/label/index.tsx
var label = __webpack_require__(67734);
// EXTERNAL MODULE: ./src/truck/overlay/index.tsx + 1 modules
var overlay = __webpack_require__(2969);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
// EXTERNAL MODULE: ./src/components/modal/index.tsx + 4 modules
var modal = __webpack_require__(40519);
;// CONCATENATED MODULE: ./src/components/legal-age-modal/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  height: auto;\n  margin: auto 0;\n  overflow-y: hidden;\n  padding: ",
        "px ",
        "px;\n  padding-bottom: ",
        "px;\n\n  > img {\n    margin-bottom: ",
        "px;\n  }\n\n  ",
        " {\n    padding: ",
        "px ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0 ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: ",
        "px;\n  width: 100%;\n\n  > :first-child {\n    border: 1px solid ",
        ";\n    margin-right: ",
        "px;\n  }\n\n  > :last-child:hover {\n    background-color: ",
        ";\n  }\n\n  > * {\n    flex-basis: 50%;\n  }\n\n  ",
        " {\n    > * {\n      flex-basis: ",
        "px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default.Standalone */.Z.Standalone).withConfig({
    componentId: "sc-6e5b3ef-0"
})(_templateObject(), function(props) {
    return props.theme.colors.primary;
}, theme/* default.spacing.cozy */.Z.spacing.cozy * 6, theme/* default.spacing.relaxed */.Z.spacing.relaxed, theme/* default.spacing.cozy */.Z.spacing.cozy * 7, theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 10, theme/* default.spacing.cozy */.Z.spacing.cozy * 15);
var StyledOverlay = (0,styled_components_browser_esm/* default */.ZP)(overlay/* default */.Z).withConfig({
    componentId: "sc-6e5b3ef-1"
})(_templateObject1(), theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-6e5b3ef-2"
})(_templateObject2(), theme/* default.spacing.cozy */.Z.spacing.cozy * 12);
var ButtonsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6e5b3ef-3"
})(_templateObject3(), theme/* default.spacing.cozy */.Z.spacing.cozy * 4, function(props) {
    return props.theme.colors.white;
}, theme/* default.spacing.comfortable */.Z.spacing.comfortable, function(props) {
    return (0,polished_es/* darken */._j)(0.05, props.theme.colors.primary);
}, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 22.5);
var LegalAgeModal = function(props) {
    var closeModal = (0,use_modal_manager/* default */.Z)().closeModal;
    var vendor = (0,use_vendor/* default */.Z)();
    var logoUrl = utils/* cloudinary.applyTransformations */.nl.applyTransformations(vendor.logo, constants/* transformations.LOGO */.S7.LOGO);
    var deny = function() {
        (0,utils/* redirectTo */.gB)("/terminos-y-condiciones");
        closeModal(props.modalId);
    };
    var accept = function() {
        dist_default().save(constants/* cookieNames.LEGAL_AGE_MODAL_CLOSED */.Qo.LEGAL_AGE_MODAL_CLOSED, 1, {
            secure: false
        });
        closeModal(props.modalId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverlay, {
        open: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    alt: vendor.name,
                    src: logoUrl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(label/* default */.Z, {
                    $color: "white",
                    $textStyle: "h3Semibold",
                    as: "p",
                    $textAlign: "center",
                    children: [
                        "\xa1Bienvenido a ",
                        vendor.name,
                        "!"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                    $color: "white",
                    $textStyle: "h4Regular",
                    as: "p",
                    $textAlign: "center",
                    children: "\xbfEres mayor de 18 a\xf1os?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default */.Z, {
                            type: "button",
                            onClick: deny,
                            children: "No"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default.Ghost */.Z.Ghost, {
                            type: "button",
                            onClick: accept,
                            children: "S\xed"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var legal_age_modal = (LegalAgeModal);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./src/gql/mutations/index.ts + 42 modules
var mutations = __webpack_require__(36651);
// EXTERNAL MODULE: ./src/truck/anchor/index.ts
var truck_anchor = __webpack_require__(75689);
// EXTERNAL MODULE: ./src/truck/notifier/index.tsx + 2 modules
var notifier = __webpack_require__(5002);
;// CONCATENATED MODULE: ./src/components/needs-to-accept-terms-and-conditions/index.tsx




function needs_to_accept_terms_and_conditions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  margin-top: ",
        "px;\n\n  ",
        " {\n    padding: 0 ",
        "px;\n    width: ",
        "px;\n  }\n"
    ]);
    needs_to_accept_terms_and_conditions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function needs_to_accept_terms_and_conditions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        void 0,
        void 0
    ]);
    needs_to_accept_terms_and_conditions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function needs_to_accept_terms_and_conditions_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        void 0,
        void 0
    ]);
    needs_to_accept_terms_and_conditions_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var buttonStyles = (0,styled_components_browser_esm/* css */.iv)(needs_to_accept_terms_and_conditions_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.cozy */.Z.spacing.cozy * 30);
var NeedsToAcceptTermsAndConditions = function(props) {
    var user = props.user, modalId = props.modalId;
    var vendor = (0,use_vendor/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_hooks_esm/* useMutation */.Db)(mutations/* acceptAgreementsMutation */.qO), 2), acceptAgreements = ref[0], loading = ref[1].loading;
    var onAcceptTermsAndConditions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            acceptAgreements({
                                variables: {
                                    acceptedTermsAndConditions: true
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        notifier/* default.error */.Z.error("Error al aceptar los t\xe9rminos y condiciones");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onAcceptTermsAndConditions() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default */.Z, {
        style: {
            overflowY: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default.Header */.Z.Header, {
                modalId: modalId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(label/* default */.Z, {
                children: [
                    "Hola",
                    " ".concat(user.firstName || "", ","),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "En",
                    " ".concat(vendor.name, " "),
                    "nos esforzamos en brindarte el mejor servicio. Por este motivo hemos actualizado y extendido nuestros",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                        href: vendor.legalTermsUrl,
                        target: "_blank",
                        $color: "info",
                        children: " T\xe9rminos y Condiciones"
                    }),
                    ".",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Al continuar usando nuestra tienda en l\xednea, est\xe1s confirmando que has le\xeddo y est\xe1s de acuerdo con ellos."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_StyledButton, {
                onClick: onAcceptTermsAndConditions,
                loading: loading,
                color: "secondary",
                children: "Aceptar y Continuar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_StyledButtonPlain, {
                onClick: function() {
                    return (0,utils/* logout */.kS)();
                },
                color: "error",
                children: "Cerrar sesi\xf3n"
            })
        ]
    });
};
/* harmony default export */ var needs_to_accept_terms_and_conditions = (NeedsToAcceptTermsAndConditions);
var _StyledButton = (0,styled_components_browser_esm/* default */.ZP)(truck_button/* default */.Z).withConfig({
    componentId: "sc-2301187f-0"
})(needs_to_accept_terms_and_conditions_templateObject1(), buttonStyles);
var _StyledButtonPlain = (0,styled_components_browser_esm/* default */.ZP)(truck_button/* default.Plain */.Z.Plain).withConfig({
    componentId: "sc-2301187f-1"
})(needs_to_accept_terms_and_conditions_templateObject2(), buttonStyles);

// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./src/components/birthdate-field/index.js
var birthdate_field = __webpack_require__(29265);
// EXTERNAL MODULE: ./src/components/text-field/index.tsx + 1 modules
var text_field = __webpack_require__(18325);
// EXTERNAL MODULE: ./src/truck/field/index.tsx + 2 modules
var field = __webpack_require__(49318);
;// CONCATENATED MODULE: ./src/components/needs-to-be-updated/elements.js

function elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: start;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  margin-top: ",
        "px;\n\n  > *:not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n  text-align: right;\n\n  ",
        " {\n    > button {\n      padding: 0 ",
        "px;\n      width: ",
        "px;\n    }\n  }\n"
    ]);
    elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var TOCContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57b4afb-0"
})(elements_templateObject(), theme/* default.spacing.relaxed */.Z.spacing.relaxed, theme/* default.spacing.cozy */.Z.spacing.cozy);
var ActionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57b4afb-1"
})(elements_templateObject1(), theme/* default.spacing.relaxed */.Z.spacing.relaxed, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.cozy */.Z.spacing.cozy * 30);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/constraints.ts
var constraints = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/utils/validators/birthdate.ts + 4 modules
var birthdate = __webpack_require__(24818);
;// CONCATENATED MODULE: ./src/components/needs-to-be-updated/utils.ts







var AccountFormFields;
(function(AccountFormFields) {
    AccountFormFields["FIRST_NAME"] = "firstName";
    AccountFormFields["LAST_NAME"] = "lastName";
    AccountFormFields["EMAIL"] = "email";
    AccountFormFields["PHONE"] = "phone";
    AccountFormFields["TELEPHONE"] = "telephone";
    AccountFormFields["BIRTHDATE"] = "birthdate";
    AccountFormFields["NEW_PASSWORD"] = "newPassword";
    AccountFormFields["CONFIRM_PASSWORD"] = "confirmPassword";
    AccountFormFields["ACCEPTED_TERMS_AND_CONDITIONS"] = "acceptedTermsAndConditions";
    AccountFormFields["ALLOW_ADVERTISING"] = "allowAdvertising";
    AccountFormFields["ACCEPTED_PRIVACY_POLICY"] = "acceptedPrivacyPolicy";
})(AccountFormFields || (AccountFormFields = {}));
var checkboxFields = [
    AccountFormFields.ACCEPTED_TERMS_AND_CONDITIONS,
    AccountFormFields.ALLOW_ADVERTISING,
    AccountFormFields.ACCEPTED_PRIVACY_POLICY, 
];
var _obj;
var formFieldConfigs = (_obj = {}, (0,_define_property/* default */.Z)(_obj, AccountFormFields.FIRST_NAME, {
    type: "text",
    label: "Nombres",
    placeholder: "Nombres",
    formatterName: "wordOnly",
    rulesConstraints: {
        required: (0,lodash.pick)(constraints/* default.firstName */.Z.firstName, "presence")
    }
}), (0,_define_property/* default */.Z)(_obj, AccountFormFields.LAST_NAME, {
    type: "text",
    label: "Apellidos",
    placeholder: "Apellidos",
    formatterName: "wordOnly",
    rulesConstraints: {
        required: (0,lodash.pick)(constraints/* default.lastName */.Z.lastName, "presence")
    }
}), (0,_define_property/* default */.Z)(_obj, AccountFormFields.EMAIL, {
    type: "email",
    label: "Correo",
    placeholder: "Correo",
    rulesConstraints: {
        default: (0,lodash.pick)(constraints/* default.email */.Z.email, "email"),
        required: (0,lodash.pick)(constraints/* default.email */.Z.email, "presence")
    }
}), (0,_define_property/* default */.Z)(_obj, AccountFormFields.PHONE, {
    type: "tel",
    label: "Celular",
    placeholder: "N\xfamero de celular",
    formatterName: "phone",
    rulesConstraints: {
        required: (0,lodash.pick)(constraints/* default.phone */.Z.phone, "presence")
    }
}), (0,_define_property/* default */.Z)(_obj, AccountFormFields.TELEPHONE, {
    type: "tel",
    label: "Tel\xe9fono",
    placeholder: "N\xfamero de tel\xe9fono",
    formatterName: "phone",
    rulesConstraints: {
        required: {
            presence: {
                message: "Ingresa tu tel\xe9fono",
                allowEmpty: false
            }
        }
    }
}), (0,_define_property/* default */.Z)(_obj, AccountFormFields.NEW_PASSWORD, {
    type: "password",
    label: "Nueva contrase\xf1a",
    placeholder: "Nueva contrase\xf1a",
    rulesConstraints: {
        default: (0,lodash.pick)(constraints/* default.newPassword */.Z.newPassword, "length"),
        required: (0,lodash.pick)(constraints/* default.newPassword */.Z.newPassword, "presence")
    }
}), (0,_define_property/* default */.Z)(_obj, AccountFormFields.CONFIRM_PASSWORD, {
    type: "password",
    label: "Confirmar contrase\xf1a",
    placeholder: "Confirmar contrase\xf1a",
    rulesConstraints: {
        default: (0,lodash.pick)(constraints/* default.confirmPassword */.Z.confirmPassword, [
            "equality",
            "length"
        ]),
        required: (0,lodash.pick)(constraints/* default.confirmPassword */.Z.confirmPassword, "presence")
    }
}), _obj);
var defaultAccountFormFields = [
    {
        name: AccountFormFields.FIRST_NAME,
        rules: {
            required: true
        }
    },
    {
        name: AccountFormFields.LAST_NAME,
        rules: {
            required: true
        }
    },
    {
        name: AccountFormFields.EMAIL,
        rules: {
            required: true
        }
    },
    {
        name: AccountFormFields.PHONE,
        rules: {
            required: true
        }
    },
    {
        name: AccountFormFields.TELEPHONE,
        rules: {
            required: false
        }
    }, 
];
function getFormFieldConfig(customField) {
    if (!Object.values(AccountFormFields).includes(customField.name)) {
        throw new Error("Field ".concat(customField.name, " is not supported"));
    }
    var customFieldName = customField.name;
    var fieldConfig = formFieldConfigs[customFieldName];
    return (0,_object_spread/* default */.Z)({
        name: customFieldName
    }, fieldConfig);
}
function getSupportedCustomFields(vendorSettings) {
    var ref;
    if ((0,lodash.isEmpty)(vendorSettings === null || vendorSettings === void 0 ? void 0 : (ref = vendorSettings.needsToBeUpdated) === null || ref === void 0 ? void 0 : ref.customFields)) {
        var ref1;
        var hasBirthdate = vendorSettings === null || vendorSettings === void 0 ? void 0 : (ref1 = vendorSettings.signup) === null || ref1 === void 0 ? void 0 : ref1.birthdate;
        var fields = (0,lodash.cloneDeep)(defaultAccountFormFields);
        if (hasBirthdate) {
            fields.push({
                name: AccountFormFields.BIRTHDATE,
                rules: {
                    required: true
                }
            });
        }
        return fields;
    }
    var fields1 = (0,lodash.cloneDeep)(vendorSettings.needsToBeUpdated.customFields);
    /**
   * If the newPassword field exists, the confirmPassword
   * field must be automatically added, since they are
   * mutually dependent.
   */ var newPasswordFieldIndex = (0,lodash.findIndex)(fields1, {
        name: AccountFormFields.NEW_PASSWORD
    });
    var newPasswordField = fields1[newPasswordFieldIndex];
    if (newPasswordField) {
        var ref2;
        fields1.splice(newPasswordFieldIndex + 1, 0, {
            name: AccountFormFields.CONFIRM_PASSWORD,
            rules: {
                required: (ref2 = newPasswordField.rules) === null || ref2 === void 0 ? void 0 : ref2.required
            }
        });
    }
    return fields1;
}
function getSupportedCustomFieldConfigs(vendorSettings) {
    return getSupportedCustomFields(vendorSettings).map(getFormFieldConfig);
}
function getFormInitialValues(user, vendorSettings) {
    var fields = getSupportedCustomFields(vendorSettings);
    return (0,lodash.pick)(user, (0,lodash.concat)((0,lodash.map)(fields, "name"), checkboxFields));
}
function getSubmitPayload(formValues, vendorSettings) {
    var fields = getSupportedCustomFields(vendorSettings);
    var fieldNames = (0,lodash.concat)((0,lodash.map)(fields, "name"), checkboxFields);
    var payload = (0,lodash.pick)(formValues, fieldNames);
    if (payload.birthdate) {
        payload.birthdate = (0,birthdate/* transformBirthdate */.z)(payload.birthdate);
    }
    return payload;
}
function onValidateFormValues(formValues, vendorSettings) {
    var ref, ref1;
    var fields = getSupportedCustomFields(vendorSettings);
    var formConstraints = (0,lodash.fromPairs)(fields.map(function(field) {
        var fieldConfig = formFieldConfigs[field.name];
        var fieldRules = fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.rulesConstraints;
        if (!fieldRules) {
            return false;
        }
        var fieldRuleKeys = (0,lodash.concat)((0,lodash.keys)((0,lodash.pickBy)(field === null || field === void 0 ? void 0 : field.rules, Boolean)), "default");
        var fieldConstraints = fieldRuleKeys.reduce(function(acc, value) {
            return (0,lodash.assign)(acc, fieldRules[value]);
        }, {});
        if ((0,lodash.isEmpty)(fieldConstraints)) {
            return false;
        }
        return [
            field.name,
            fieldConstraints
        ];
    }).filter(Boolean));
    var errors = (0,utils/* getValidator */.Te)(formConstraints)(formValues);
    var birthDateConfig = (0,lodash.find)(fields, {
        name: AccountFormFields.BIRTHDATE
    });
    var birthdate = utils/* formValidators.birthdateField */.BQ.birthdateField({
        birthdate: formValues.birthdate,
        settings: (vendorSettings === null || vendorSettings === void 0 ? void 0 : (ref = vendorSettings.signup) === null || ref === void 0 ? void 0 : ref.birthdate) && !!birthDateConfig,
        isRequired: birthDateConfig === null || birthDateConfig === void 0 ? void 0 : (ref1 = birthDateConfig.rules) === null || ref1 === void 0 ? void 0 : ref1.required
    }).birthdate;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errors), {
        birthdate: birthdate
    });
}

;// CONCATENATED MODULE: ./src/components/needs-to-be-updated/index.tsx




function needs_to_be_updated_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: ",
        "px;\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr;\n  }\n"
    ]);
    needs_to_be_updated_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




















var StyledFormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3d3c4636-0"
})(needs_to_be_updated_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
}, (0,styled_breakpoints.up)("lg"));
var NeedsToBeUpdated = function(props) {
    var user = props.user, modalId = props.modalId;
    var vendor = (0,use_vendor/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_hooks_esm/* useMutation */.Db)(mutations/* updateUserMutation */.dY), 1), updateUser = ref[0];
    var formatters = (0,hooks/* useFormatters */.zZ)();
    var vendorName = vendor.name, legalTermsUrl = vendor.legalTermsUrl, privacyPolicyUrl = vendor.privacyPolicyUrl;
    var initialValues = react.useMemo(function() {
        return getFormInitialValues(user, vendor.settings);
    }, [
        user,
        vendor.settings
    ]);
    var formFields = react.useMemo(function() {
        return getSupportedCustomFieldConfigs(vendor.settings);
    }, [
        vendor.settings
    ]);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var payload, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getSubmitPayload(values, vendor.settings)
                        ];
                    case 1:
                        payload = _state.sent();
                        return [
                            4,
                            updateUser({
                                variables: payload
                            })
                        ];
                    case 2:
                        _state.sent();
                        window.scrollTo(0, 0);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            2,
                            (0,utils/* handleSubmissionErrors */.ou)(error)
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var allowAdvertisingFF = (0,toggled_esm/* useFeature */.SS)(constants/* flags.ALLOW_ADVERTISING */.id.ALLOW_ADVERTISING);
    var renderContent = function(formProps) {
        var ref;
        var canSubmit = (!legalTermsUrl || formProps.values.acceptedTermsAndConditions) && (!privacyPolicyUrl || formProps.values.acceptedPrivacyPolicy);
        var hasCheckBoxes = legalTermsUrl || privacyPolicyUrl || !!allowAdvertisingFF;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        overflowY: "auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormContainer, {
                            children: formFields.map(function(field) {
                                if (field.name === "birthdate") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(birthdate_field/* default */.Z, {})
                                    }, field.name);
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_field/* default */.Z, {
                                        as: "input",
                                        type: field.type,
                                        label: field.label,
                                        placeholder: field.placeholder,
                                        name: field.name,
                                        parse: formatters[field.formatterName]
                                    })
                                }, field.name);
                            })
                        }),
                        hasCheckBoxes && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TOCContainer, {
                            children: [
                                legalTermsUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(field/* default */.Z, {
                                    as: "checkbox",
                                    name: "acceptedTermsAndConditions",
                                    hasText: true,
                                    textStyle: "h6Regular",
                                    children: [
                                        "Declaro que he le\xeddo y acepto los ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                                            href: "/terminos-y-condiciones",
                                            target: "_blank",
                                            $textStyle: "h6Regular",
                                            $color: "info",
                                            children: "T\xe9rminos y Condiciones"
                                        }),
                                        " de ".concat(vendorName)
                                    ]
                                }),
                                privacyPolicyUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(field/* default */.Z, {
                                    as: "checkbox",
                                    name: "acceptedPrivacyPolicy",
                                    hasText: true,
                                    textStyle: "h6Regular",
                                    children: [
                                        "Declaro que he le\xeddo y acepto la ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                                            href: "/politica-de-privacidad",
                                            target: "_blank",
                                            $textStyle: "h6Regular",
                                            $color: "info",
                                            children: "Pol\xedtica de Privacidad"
                                        }),
                                        " de ".concat(vendorName)
                                    ]
                                }),
                                allowAdvertisingFF ? /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                                    as: "checkbox",
                                    name: "allowAdvertising",
                                    hasText: true,
                                    textStyle: "h6Regular",
                                    children: ((ref = allowAdvertisingFF.settings) === null || ref === void 0 ? void 0 : ref.message) ? allowAdvertisingFF.settings.message : "Brindo mi consentimiento para recibir publicidad sobre ofertas," + " promociones e informaci\xf3n sobre productos de la tienda."
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default */.Z, {
                        disabled: !canSubmit,
                        loading: formProps.submitting,
                        onClick: formProps.handleSubmit,
                        color: "secondary",
                        children: "Guardar y Continuar"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default.Header */.Z.Header, {
                    modalId: modalId,
                    title: "Bienvenido, actualiza tus datos por favor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                    initialValues: initialValues,
                    onSubmit: onSubmit,
                    validate: function(formValues) {
                        return onValidateFormValues(formValues, vendor.settings);
                    },
                    children: renderContent
                })
            ]
        })
    });
};
/* harmony default export */ var needs_to_be_updated = (NeedsToBeUpdated);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/truck/utils/index.ts + 8 modules
var truck_utils = __webpack_require__(14250);
// EXTERNAL MODULE: ./src/components/dialog/header.tsx
var header = __webpack_require__(79600);
// EXTERNAL MODULE: ./src/components/dialog/modal.tsx
var dialog_modal = __webpack_require__(56403);
// EXTERNAL MODULE: ./src/components/order-status/index.tsx
var order_status = __webpack_require__(61525);
;// CONCATENATED MODULE: ./src/components/order-to-review-modal/index.tsx

function order_to_review_modal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 3px;\n  box-shadow:\n    0px 16px 24px rgba(0, 0, 0, 0.14),\n    0px 6px 30px rgba(0, 0, 0, 0.12),\n    0px 8px 10px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  padding: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    order_to_review_modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function order_to_review_modal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  padding: 0 ",
        "px;\n\n  > img {\n    margin-bottom: ",
        "px;\n\n    ",
        ";\n\n    ",
        " {\n      ",
        ";\n    }\n  }\n\n  > ",
        ":not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    order_to_review_modal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function order_to_review_modal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: ",
        "px;\n  padding: ",
        "px ",
        "px;\n  width: fit-content;\n"
    ]);
    order_to_review_modal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f4c473bb-0"
})(order_to_review_modal_templateObject(), function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.cozy * 3;
});
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f4c473bb-1"
})(order_to_review_modal_templateObject1(), function(props) {
    return props.theme.spacing.cozy * 3.5;
}, function(props) {
    return props.theme.spacing.relaxed;
}, (0,truck_utils/* getSizeStyle */.Xn)(theme/* default.spacing.cozy */.Z.spacing.cozy * 6), (0,styled_breakpoints.up)("lg"), (0,truck_utils/* getSizeStyle */.Xn)(theme/* default.spacing.cozy */.Z.spacing.cozy * 9), label/* default */.Z, function(props) {
    return props.theme.spacing.cozy;
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(truck_button/* default */.Z).withConfig({
    componentId: "sc-f4c473bb-2"
})(order_to_review_modal_templateObject2(), theme/* default.spacing.cozy */.Z.spacing.cozy * 4, theme/* default.spacing.cozy */.Z.spacing.cozy * 1.5, theme/* default.spacing.relaxed */.Z.spacing.relaxed);
var OrderToReviewModal = function(props) {
    var ref;
    var orderStatus = props.orderStatus, orderId = props.orderId, onClose = props.onClose, modalId = props.modalId;
    var closeModal = (0,hooks/* useModalManager */.$C)().closeModal;
    var handleClose = function() {
        onClose();
        closeModal(modalId);
    };
    var ref1 = (0,react_hooks_esm/* useQuery */.aM)(queries/* orderStatusesQuery */.Fr), data = ref1.data, loading = ref1.loading, error = ref1.error;
    if (loading) {
        return null;
    }
    if (error || !(data === null || data === void 0 ? void 0 : (ref = data.vendor) === null || ref === void 0 ? void 0 : ref.orderStatuses)) {
        console.error("Error al cargar los estados de pedido:", error);
        handleClose();
        return null;
    }
    var orderToReviewStatus = (0,lodash.find)(data.vendor.orderStatuses, function(status) {
        return status.slug === orderStatus;
    });
    if (!orderToReviewStatus) {
        console.error("No se encontr\xf3 el estado de pedido:", orderStatus);
        (0,utils/* notifySentry */.Yw)(error);
        handleClose();
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_modal/* DialogModal */.O, {
        onClose: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* DialogHeader */.fK, {
                    closable: true,
                    onClose: handleClose,
                    closeIconSize: "md",
                    closeIconColor: "black30"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "icon",
                            src: constants/* images.ILLUSTRATION_RATING */.Wc.ILLUSTRATION_RATING
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                            as: "h4",
                            $textStyle: "h4Semibold",
                            $textAlign: "center",
                            children: "Califica tus pedidos"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(label/* default */.Z, {
                            as: "p",
                            $color: "grayscale60",
                            $textAlign: "center",
                            children: [
                                "Tu \xfaltimo pedido en estado ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(order_status/* default */.Z, {
                                    name: orderToReviewStatus.name,
                                    color: orderToReviewStatus.color
                                }),
                                " ",
                                "espera tu calificaci\xf3n."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/mi-cuenta/pedidos/".concat(orderId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        onClick: handleClose,
                        children: "Ver pedido"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var order_to_review_modal = (OrderToReviewModal);

// EXTERNAL MODULE: ./src/components/index.ts + 136 modules
var components = __webpack_require__(13823);
;// CONCATENATED MODULE: ./src/components/orders-to-be-approved-alert/elements.js

function orders_to_be_approved_alert_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        "px;\n  box-shadow:\n    0px 16px 24px rgba(0, 0, 0, 0.14),\n    0px 6px 30px rgba(0, 0, 0, 0.12),\n    0px 8px 10px rgba(0, 0, 0, 0.2);\n  height: auto;\n  left: 50%;\n  max-width: ",
        "px;\n  overflow-y: hidden;\n  padding: ",
        "px;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 95%;\n\n  ",
        " {\n    max-width: ",
        "px;\n    width: auto;\n  }\n"
    ]);
    orders_to_be_approved_alert_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function orders_to_be_approved_alert_elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: ",
        "px;\n  padding: ",
        "px ",
        "px;\n  width: fit-content;\n"
    ]);
    orders_to_be_approved_alert_elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ModalContainer = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-d186c6c2-0"
})(orders_to_be_approved_alert_elements_templateObject(), theme/* default.spacing.compact */.Z.spacing.compact, theme/* default.spacing.cozy */.Z.spacing.cozy * 45, theme/* default.spacing.relaxed */.Z.spacing.relaxed, (0,styled_breakpoints.up)("md"), theme/* default.spacing.cozy */.Z.spacing.cozy * 62);
var elements_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(truck_button/* default */.Z).withConfig({
    componentId: "sc-d186c6c2-1"
})(orders_to_be_approved_alert_elements_templateObject1(), theme/* default.spacing.cozy */.Z.spacing.cozy * 4, theme/* default.spacing.cozy */.Z.spacing.cozy * 1.5, theme/* default.spacing.relaxed */.Z.spacing.relaxed);

// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
;// CONCATENATED MODULE: ./src/components/orders-to-be-approved-alert/header.js

function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: ",
        "px;\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14d294a7-0"
})(header_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy);
var Header = function(props) {
    var onClose = props.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
            color: "black30",
            onClick: onClose,
            type: "close",
            size: "md"
        })
    });
};
/* harmony default export */ var orders_to_be_approved_alert_header = (Header);

;// CONCATENATED MODULE: ./src/components/orders-to-be-approved-alert/index.js








var OrdersToBeApprovedAlert = function(props) {
    var initialOrderStatusId = props.initialOrderStatusId, modalId = props.modalId;
    var closeModal = (0,hooks/* useModalManager */.$C)().closeModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(orders_to_be_approved_alert_header, {
                onClose: function() {
                    return closeModal(modalId);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Message */.v0, {
                title: "Tienes cambios por aprobar",
                content: "Algunos de los pedidos registrados en la tienda han tenido cambios y esperan de tu aprobaci\xf3n para continuar siendo atendidos.",
                imageSrc: constants/* images.ILLUSTRATION_PAPER_PROBLEM */.Wc.ILLUSTRATION_PAPER_PROBLEM
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/mi-cuenta/pedidos?status=".concat(initialOrderStatusId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_StyledButton, {
                    onClick: function() {
                        return closeModal(modalId);
                    },
                    children: "Ver pedidos"
                })
            })
        ]
    });
};
/* harmony default export */ var orders_to_be_approved_alert = (OrdersToBeApprovedAlert);

// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./src/components/wysiwyg/index.ts
var wysiwyg = __webpack_require__(58309);
;// CONCATENATED MODULE: ./src/components/under-construction-modal/index.tsx

function under_construction_modal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  height: auto;\n  justify-content: center;\n  overflow-y: hidden;\n  padding: ",
        "px;\n  padding-bottom: ",
        "px;\n\n  ",
        " {\n    padding: ",
        "px;\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    under_construction_modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function under_construction_modal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 0 ",
        "px;\n"
    ]);
    under_construction_modal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var under_construction_modal_StyledModal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default.Standalone */.Z.Standalone).withConfig({
    componentId: "sc-fc512bed-0"
})(under_construction_modal_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy * 5, theme/* default.spacing.cozy */.Z.spacing.cozy * 4, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 10, theme/* default.spacing.cozy */.Z.spacing.cozy * 9);
var under_construction_modal_StyledOverlay = (0,styled_components_browser_esm/* default */.ZP)(overlay/* default */.Z).withConfig({
    componentId: "sc-fc512bed-1"
})(under_construction_modal_templateObject1(), theme/* default.spacing.comfortable */.Z.spacing.comfortable);
function UnderConstructionModal() {
    var vendor = (0,use_vendor/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(under_construction_modal_StyledOverlay, {
        open: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(under_construction_modal_StyledModal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(wysiwyg/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wysiwyg",
                    children: (0,lib/* default */.ZP)(vendor.settings.underConstructionContent)
                })
            ]
        })
    });
}
/* harmony default export */ var under_construction_modal = (UnderConstructionModal);

;// CONCATENATED MODULE: ./src/components/pop-up/index.js


















var PopUp = function() {
    var ref, ref1, ref2;
    var orderReviewFF = (0,toggled_esm/* useFeature */.SS)(constants/* flags.ORDER_REVIEW */.id.ORDER_REVIEW);
    var variables = {
        orderStatusSlug: constants/* orderStatuses.TO_BE_APPROVED */.bs.TO_BE_APPROVED,
        skipOrderReviewReminder: !orderReviewFF
    };
    var data = (0,react_hooks_esm/* useQuery */.aM)(queries/* userPopupQuery */.YK, {
        variables: variables
    }).data;
    var ref3;
    var user = (ref3 = data === null || data === void 0 ? void 0 : data.user) !== null && ref3 !== void 0 ? ref3 : {};
    var storeId = dist_default().load(constants/* cookieNames.STORE_ID */.Qo.STORE_ID);
    var acceptedCookies = dist_default().load(constants/* cookieNames.ACCEPTED_COOKIES */.Qo.ACCEPTED_COOKIES);
    var legalAgeModalClosed = dist_default().load(constants/* cookieNames.LEGAL_AGE_MODAL_CLOSED */.Qo.LEGAL_AGE_MODAL_CLOSED);
    var vendor = (0,use_vendor/* default */.Z)();
    var orders = user === null || user === void 0 ? void 0 : (ref = user.orders) === null || ref === void 0 ? void 0 : ref.items;
    var orderToApprove = (0,lodash.find)(orders, {
        status: {
            slug: constants/* orderStatuses.TO_BE_APPROVED */.bs.TO_BE_APPROVED
        }
    });
    var needsUserApprovalForCookies = (0,toggled_esm/* useFlag */.P5)(constants/* flags.COOKIES_NEED_USER_APPROVAL */.id.COOKIES_NEED_USER_APPROVAL);
    var hasStoreNavigation = (0,toggled_esm/* useFlag */.P5)(constants/* flags.STORE_NAVIGATION */.id.STORE_NAVIGATION);
    var hasLegalAgeModal = (0,toggled_esm/* useFlag */.P5)(constants/* flags.LEGAL_AGE_MODAL */.id.LEGAL_AGE_MODAL);
    var hasLoginRequiredFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.LOGIN_REQUIRED */.id.LOGIN_REQUIRED);
    var hasUnderConstructionModal = (0,toggled_esm/* useFlag */.P5)(constants/* flags.UNDER_CONSTRUCTION_MODAL */.id.UNDER_CONSTRUCTION_MODAL);
    var ref4 = (0,use_modal_manager/* default */.Z)(), openModal = ref4.openModal, closeModal = ref4.closeModal;
    var isLoggedOutPrivateLogin = hasLoginRequiredFF && !user.isLoggedIn;
    var externalPaths = [
        "/terminos-y-condiciones",
        "/politica-de-privacidad",
        "/libro-de-reclamaciones"
    ];
    var pathIsExternalToNavigation = externalPaths.includes(window.location.pathname);
    (0,use_isomorphic_layout_effect/* default */.Z)(function() {
        if (pathIsExternalToNavigation) {
            return;
        }
        var modalId;
        if (hasUnderConstructionModal) {
            modalId = openModal(under_construction_modal);
        } else if (user.needsToBeUpdated) {
            modalId = openModal(needs_to_be_updated, {
                user: user
            });
        } else if (vendor.legalTermsUrl && user.needsToAcceptTermsAndConditions) {
            modalId = openModal(needs_to_accept_terms_and_conditions, {
                user: user
            });
        } else if (hasStoreNavigation && !storeId) {
            modalId = openModal(buying_in_store_selector/* default */.Z);
        } else if (orderToApprove) {
            modalId = openModal(orders_to_be_approved_alert, {
                initialOrderStatusId: orderToApprove.status.id
            });
        }
        return function() {
            if (modalId) {
                closeModal(modalId);
            }
        };
    }, [
        user.needsToBeUpdated,
        user.needsToAcceptTermsAndConditions,
        storeId,
        user.isLoggedIn
    ]);
    var isHomePath = window.location.pathname === "/";
    var showOrderReviewReminder = user === null || user === void 0 ? void 0 : (ref1 = user.needsReminderForOrderReview) === null || ref1 === void 0 ? void 0 : ref1.status;
    var orderIdToReview = user === null || user === void 0 ? void 0 : (ref2 = user.needsReminderForOrderReview) === null || ref2 === void 0 ? void 0 : ref2.orderId;
    var ref5 = (0,react.useState)(false), orderReviewReminderClosed = ref5[0], setOrderReviewReminderClosed = ref5[1];
    (0,use_isomorphic_layout_effect/* default */.Z)(function() {
        if (pathIsExternalToNavigation || isLoggedOutPrivateLogin) {
            return;
        }
        var modalId;
        if (hasLegalAgeModal && !legalAgeModalClosed) {
            modalId = openModal(legal_age_modal);
        } else if (needsUserApprovalForCookies && !acceptedCookies) {
            modalId = openModal(cookies_alert);
        } else if (showOrderReviewReminder && isHomePath && !orderReviewReminderClosed) {
            var ref;
            modalId = openModal(order_to_review_modal, {
                orderId: orderIdToReview,
                orderStatus: (ref = orderReviewFF.settings) === null || ref === void 0 ? void 0 : ref.status,
                onClose: function() {
                    return setOrderReviewReminderClosed(true);
                }
            });
        }
        return function() {
            if (modalId) {
                closeModal(modalId);
            }
        };
    }, [
        window.location.pathname,
        showOrderReviewReminder,
        isLoggedOutPrivateLogin
    ]);
    return null;
};
/* harmony default export */ var pop_up = (PopUp);


/***/ })

}]);